var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_9435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0847 6.1708C12.8045 4.94613 12.1096 3.85596 11.1177 3.08499C10.1258 2.31402 8.8979 1.90966 7.64198 1.94041H7.63566C6.38056 1.90911 5.15319 2.31248 4.16135 3.08225C3.16952 3.85202 2.47416 4.94087 2.19299 6.16448C1.45425 9.42251 3.44948 12.1817 5.25528 13.9181C5.89405 14.5376 6.74895 14.8841 7.63882 14.8841C8.52869 14.8841 9.3836 14.5376 10.0224 13.9181C11.8282 12.1817 13.8234 9.42882 13.0847 6.1708ZM7.64198 9.33411C7.24861 9.33411 6.86407 9.21747 6.537 8.99892C6.20992 8.78038 5.955 8.46975 5.80446 8.10633C5.65393 7.7429 5.61454 7.343 5.69128 6.95719C5.76803 6.57137 5.95745 6.21698 6.23561 5.93883C6.51376 5.66068 6.86815 5.47125 7.25396 5.39451C7.63977 5.31776 8.03968 5.35715 8.4031 5.50769C8.76653 5.65822 9.07715 5.91315 9.2957 6.24022C9.51424 6.5673 9.63089 6.95183 9.63089 7.3452C9.63089 7.8727 9.42134 8.37858 9.04835 8.75158C8.67536 9.12457 8.16947 9.33411 7.64198 9.33411Z",
    fill: "#253241"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_9435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1536,
    height: 15.1536,
    fill: "white",
    transform: "translate(0.0664062 0.835449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7effd358f2a62dc84b828b9d73013908.svg";
export { ForwardRef as ReactComponent };